import PropTypes from 'prop-types';
import {useState} from 'react';

const ProductDetailInfo = ({data}) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className={'flex flex-col gap-2'}>
      <div className={'font-semibold font-serif-custom lg:text-lg text-primary-900'}>Product Details:</div>
      <div className={'flex justify-start'}>
        <div className={'w-1/2 text-sm'}>
          <span className={'font-semibold'}>Product Type:</span>{' '}
          <span className={'capitalize'}>{data.jewelryType}</span>
        </div>
        <div className={'text-sm'}>
          <span className={'font-semibold'}>Type:</span>{' '}
          <span className={'capitalize'}>{data.productType}</span>
        </div>
      </div>

      <div className={'flex justify-start'}>
        <div className={'w-1/2 text-sm'}>
          <span className={'font-semibold'}>Gross weight:</span>{' '}
          <span>{data.weight?.grossWeight}</span>
        </div>
        <div className={'text-sm'}>
          <span className={'font-semibold'}>Net weight:</span>{' '}
          <span>{data.weight?.netWeight}</span>
        </div>
      </div>

      <div className={'lg:mr-5 mr-4 mb-3'}>
        <span className={'text-sm font-semibold'}>Description:</span>{' '}
        <div className={showMore ? 'text-justify text-sm' : 'text-justify text-sm line-clamp-2 capitalize'}>
          {(data.description)}
        </div>
        {data.description?.length > 100 && (
          <button
            onClick={() => setShowMore(prev => !prev)}
            className={'text-primary-600 font-medium  focus:outline-none text-sm'}
          >
            {showMore ? 'Show less' : 'Read more'}
          </button>
        )}
      </div>
    </div>
  );
};

ProductDetailInfo.propTypes = {
  data: PropTypes.shape({
    jewelryType: PropTypes.string,
    productType: PropTypes.string,
    weight: PropTypes.shape({
      grossWeight: PropTypes.string,
      netWeight: PropTypes.string,
    }),
    description: PropTypes.string,
  }).isRequired,
};

export default ProductDetailInfo;
